import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
    standalone: false,
    selector: 'res-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
    @ViewChild('filterInput') private inputElement: ElementRef;

    @Input() maxChars: number;
    @Input() placeholder: string;
    @Input() callback: any;
    @Input() filterQuery = '';
    @Input() isDisabled = false;
    @Input() filterInputAutoId: string;
    @Input() clearButtonDataAutoId: string;
    @Input() autofocusInput: boolean;
    @Input() isFilteringInProgress: boolean;

    private originalPlaceholder;
    private lastQuery = '';

    constructor(private renderer: Renderer2) { }

    ngOnInit() {
        this.originalPlaceholder = this.placeholder;
    }

    onFilter(event?) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        const trimmed = this.filterQuery.trim().toLowerCase();
        if (trimmed !== this.lastQuery) {
            this.lastQuery = trimmed;
            this.callback(trimmed);
        }
    }

    clear() {
        this.filterQuery = '';
        this.placeholder = this.originalPlaceholder;
        this.onFilter();
    }

    onBlur() {
        if (this.filterQuery.length < 1) {
            this.placeholder = this.originalPlaceholder;
        }
    }
}

